import React from 'react';
import PropTypes from 'prop-types';

import StarburstCar from 'components/svgs/starburst-car';

const propTypes = {
  dismiss: PropTypes.func.isRequired,
};

const PositiveReviewResponse = ({ dismiss }) => (
  <div className="review-modal background-color-white text-center border-radius-4 position-relative padding-vertical-30 padding-horizontal-50">
    <div className="row">
      <div className="col-xs-12">
        <div className="text-size-28 text-color-blue margin-vertical-30 text-weight-book">
          Thank you for sharing your thoughts!
        </div>
      </div>
      <div className="col-xs-12 margin-vertical-40">
        <StarburstCar />
      </div>
      <div className="col-xs-12 dismiss-modal text-align-left text-color-green text-size-24 clickable" onClick={dismiss}>
        GOT IT
        <span className="iconified-font iconified-checkmark text-color-green padding-left-10" />
      </div>
    </div>
  </div>
);

PositiveReviewResponse.propTypes = propTypes;
export default PositiveReviewResponse;
